'use strict';

const saBecomeGuideButton = [
  '$state',
  'userModel',
  'guideStatus',

  function ($state, userModel, guideStatus) {
    return {
      restrict: 'A',
      link: {
        pre: function ($scope, $element, $attr) {
          var state = (!userModel.item.id || !guideStatus.isGuide()) ? 'becomeGuide' : 'settings';

          $attr.$set('href', $state.href(state));
        }
      }
    };
  }
];

export default saBecomeGuideButton;



// WEBPACK FOOTER //
// ./app/src/directives/become_guide_button.js